// @flow
import React from "react";
import I18n from "../../../i18n/I18n";
import { Icon } from "../";
import styles from "./SearchString.scss";

const SearchString = props => {
  const { search, clearSearch } = props;
  return (
    <div className={styles.searchString}>
      {I18n.getText("orders.search-result")}
      &nbsp;
      <strong>{`"${search}"`}</strong>
      <button className={styles.clearIcon} onClick={() => clearSearch()}>
        <Icon name="close" />
      </button>
    </div>
  );
};

export default SearchString;



// WEBPACK FOOTER //
// ./src/components/common/searchString/SearchString.js